var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExitAdjustment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.79 16.4L21.66 14.27C21.38 13.99 20.93 13.99 20.66 14.27L14.06 20.87V24H17.19L23.79 17.4C24.07 17.12 24.07 16.67 23.79 16.4ZM16.6 22.58H15.47V21.45L19.02 17.9L20.15 19.03L16.6 22.58ZM21.16 18.02L20.03 16.89L21.16 15.76L22.29 16.89L21.16 18.02Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79 19.5H10.5C10.84 19.5 11.17 19.36 11.41 19.12C11.65 18.88 11.79 18.55 11.79 18.21V16.28H10.5V18.21H2.79V2.79H10.5V4.72H11.79V2.79C11.79 2.45 11.65 2.12 11.41 1.88C11.17 1.64 10.84 1.5 10.5 1.5H2.79C2.45 1.5 2.12 1.64 1.88 1.88C1.64 2.12 1.5 2.44 1.5 2.79V18.22C1.5 18.56 1.64 18.89 1.88 19.13C2.12 19.37 2.45 19.51 2.79 19.51V19.5Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.16 13.45L14.47 11.14H5.36V9.85H14.47L12.16 7.54L13.07 6.63L16.93 10.49L13.07 14.35L12.16 13.44V13.45Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExitAdjustment);
export default __webpack_public_path__ + "static/media/ic-exit-adjustment.32c9851ff0cd6fd2612e3de033e1c711.svg";
export { ForwardRef as ReactComponent };